import React from 'react';
import classNames from 'classnames';
import { Container } from './container';
import { Link } from 'gatsby';
import { G2Tag } from './g2/tag';
import {
  FacebookLogo,
  InstagramLogo,
  LinkedinLogo,
  XLogo,
} from '@phosphor-icons/react';
import AlloyAutomationLogo from '../../static/images/logo/rebrand/alloy-automation.svg';

export const SiteFooter = ({ hideFooterMenu }) => {
  const CARET_DOWN = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M4 6.5L8 10.5L12 6.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <footer className="overflow-hidden bg-white">
      <Container>
        <div
          className={classNames(
            'my-6 flex items-center justify-between sm:mb-[74px] sm:mt-10',
            {
              'my-6 !justify-center': hideFooterMenu,
            }
          )}
        >
          <Link to="/">
            <img
              src={AlloyAutomationLogo}
              alt="alloy-automation"
              className="h-6 w-auto sm:h-10"
            />
          </Link>
          <G2Tag
            className={classNames('hidden sm:block', {
              '!hidden': hideFooterMenu,
            })}
          />
        </div>
        <div
          className={classNames('relative block', {
            hidden: hideFooterMenu,
          })}
        >
          <div className="grid grid-cols-1 sm:grid-cols-4 sm:gap-6">
            <div>
              {/** Platforms */}
              <div>
                <input
                  className="peer hidden"
                  id="platform-drawer"
                  type="checkbox"
                />
                <label
                  className="flex items-center justify-between border-b border-b-black/10 py-3 text-base font-semibold text-black/80 sm:border-none sm:py-0 sm:text-sm peer-checked:[&_div]:-rotate-180"
                  htmlFor="platform-drawer"
                >
                  Platform
                  <div className="block transition-smooth sm:hidden">
                    {CARET_DOWN}
                  </div>
                </label>
                <div className="hidden peer-checked:block sm:block">
                  <div className="my-4 flex flex-col space-y-4 text-[13px] text-black/60">
                    <Link
                      to="/platform/overview/"
                      className="hover:text-azure-800"
                    >
                      The Alloy Platform
                    </Link>
                    <Link
                      to="/platform/why-alloy/"
                      className="hover:text-azure-800"
                    >
                      Why Alloy?
                    </Link>
                    <Link
                      to="/platform/pricing/"
                      className="hover:text-azure-800"
                    >
                      Pricing
                    </Link>
                  </div>
                </div>
              </div>

              {/** Capabilites */}
              <div>
                <input
                  className="peer hidden"
                  id="capabilities-drawer"
                  type="checkbox"
                />
                <label
                  className="flex items-center justify-between border-b border-b-black/10 py-3 text-base font-semibold text-black/80 sm:mt-6 sm:border-none sm:py-0 sm:text-sm peer-checked:[&_div]:-rotate-180"
                  htmlFor="capabilities-drawer"
                >
                  Capabilities
                  <div className="block transition-smooth sm:hidden">
                    {CARET_DOWN}
                  </div>
                </label>
                <div className="hidden peer-checked:block sm:block">
                  <div className="my-4 flex flex-col space-y-4 text-[13px] text-black/60">
                    <Link to="/integrations/" className="hover:text-azure-800">
                      Connector Library
                    </Link>
                    <Link
                      to="/platform/ai-agents/"
                      className="hover:text-azure-800"
                    >
                      AI Agents
                    </Link>
                    <Link
                      to="/platform/on-premise/"
                      className="hover:text-azure-800"
                    >
                      On Premise
                    </Link>
                    <Link
                      to="/platform/error-handling/"
                      className="hover:text-azure-800"
                    >
                      Error Handling & Logging
                    </Link>
                    <Link
                      to="/platform/data-transformations/"
                      className="hover:text-azure-800"
                    >
                      ETL/ELT
                    </Link>
                    <Link
                      to="/platform/bespoke-customizations/"
                      className="hover:text-azure-800"
                    >
                      Bespoke Customizations
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div>
              {/** Products */}
              <div>
                <input
                  className="peer hidden"
                  id="products-drawer"
                  type="checkbox"
                />
                <label
                  className="flex items-center justify-between border-b border-b-black/10 py-3 text-base font-semibold text-black/80 sm:border-none sm:py-0 sm:text-sm peer-checked:[&_div]:-rotate-180"
                  htmlFor="products-drawer"
                >
                  Products
                  <div className="block transition-smooth sm:hidden">
                    {CARET_DOWN}
                  </div>
                </label>
                <div className="hidden peer-checked:block sm:block">
                  <div className="my-4 flex flex-col space-y-4 text-[13px] text-black/60">
                    <Link
                      to="/platform/embedded/"
                      className="hover:text-azure-800"
                    >
                      Embedded Integrations
                    </Link>
                    <Link
                      to="/platform/enterprise-ipaas/"
                      className="hover:text-azure-800"
                    >
                      Enterprise iPaaS
                    </Link>
                  </div>
                </div>
              </div>

              {/** Integrations */}
              <div>
                <input
                  className="peer hidden"
                  id="integrations-drawer"
                  type="checkbox"
                />
                <label
                  className="flex items-center justify-between border-b border-b-black/10 py-3 text-base font-semibold text-black/80 sm:mt-6 sm:border-none sm:py-0 sm:text-sm peer-checked:[&_div]:-rotate-180"
                  htmlFor="integrations-drawer"
                >
                  Popular Integrations
                  <div className="block transition-smooth sm:hidden">
                    {CARET_DOWN}
                  </div>
                </label>
                <div className="hidden peer-checked:block sm:block">
                  <div className="my-4 flex flex-col space-y-4 text-[13px] text-black/60">
                    <Link
                      to="/solutions/popular-integrations/netsuite/"
                      className="hover:text-azure-800"
                    >
                      NetSuite
                    </Link>
                    <Link
                      to="/solutions/popular-integrations/sap-s4hana/"
                      className="hover:text-azure-800"
                    >
                      SAP (S/4HANA)
                    </Link>
                    <Link
                      to="/solutions/popular-integrations/microsoft-dynamics-365-business-central/"
                      className="hover:text-azure-800"
                    >
                      Microsoft Dynamics
                    </Link>
                    <Link
                      to="/solutions/popular-integrations/shopify/"
                      className="hover:text-azure-800"
                    >
                      Shopify
                    </Link>
                    <Link
                      to="/solutions/popular-integrations/amazon/"
                      className="hover:text-azure-800"
                    >
                      Amazon
                    </Link>
                    <Link
                      to="/solutions/popular-integrations/adp-workforce-now/"
                      className="hover:text-azure-800"
                    >
                      ADP
                    </Link>
                    <Link
                      to="/solutions/popular-integrations/service-now/"
                      className="hover:text-azure-800"
                    >
                      ServiceNow
                    </Link>
                    <Link
                      to="/solutions/popular-integrations/salesforce/"
                      className="hover:text-azure-800"
                    >
                      Salesforce
                    </Link>
                    <Link
                      to="/solutions/popular-integrations/workday/"
                      className="hover:text-azure-800"
                    >
                      Workday
                    </Link>
                    <Link to="/integrations/" className="hover:text-azure-800">
                      View All
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div>
              {/** Developers */}
              <input
                className="peer hidden"
                id="developers-drawer"
                type="checkbox"
              />
              <label
                className="flex items-center justify-between border-b border-b-black/10 py-3 text-base font-semibold text-black/80 sm:border-none sm:py-0 sm:text-sm peer-checked:[&_div]:-rotate-180"
                htmlFor="developers-drawer"
              >
                Developers
                <div className="block transition-smooth sm:hidden">
                  {CARET_DOWN}
                </div>
              </label>
              <div className="hidden peer-checked:block sm:block">
                <div className="my-4 flex flex-col space-y-4 text-[13px] text-black/60">
                  <a
                    href="https://docs.runalloy.com/embedded/quick-start/"
                    target="_blank"
                    rel="nofollow noreferrer"
                    className="hover:text-azure-800"
                  >
                    Alloy Embedded
                  </a>
                  <a
                    href="https://docs.runalloy.com/embedded/workflow-builder/"
                    target="_blank"
                    rel="nofollow noreferrer"
                    className="hover:text-azure-800"
                  >
                    Building Workflows
                  </a>
                  <a
                    href="https://docs.runalloy.com/embedded/styling-the-modal/"
                    target="_blank"
                    rel="nofollow noreferrer"
                    className="hover:text-azure-800"
                  >
                    Customization Options
                  </a>
                  <a
                    href="https://docs.runalloy.com/flow/quick-start/"
                    target="_blank"
                    rel="nofollow noreferrer"
                    className="hover:text-azure-800"
                  >
                    Alloy Flow
                  </a>
                  <a
                    href="https://docs.runalloy.com/flow/popular-workflows-and-automations/"
                    target="_blank"
                    rel="nofollow noreferrer"
                    className="hover:text-azure-800"
                  >
                    Popular Workflows & Automations
                  </a>
                  <a
                    href="https://docs.runalloy.com/flow/running-workflows/"
                    target="_blank"
                    rel="nofollow noreferrer"
                    className="hover:text-azure-800"
                  >
                    Releasing a Workflow
                  </a>
                </div>
              </div>
            </div>
            <div>
              {/** Resources */}
              <div>
                <input
                  className="peer hidden"
                  id="resources-drawer"
                  type="checkbox"
                />
                <label
                  className="flex items-center justify-between border-b border-b-black/10 py-3 text-base font-semibold text-black/80 sm:border-none sm:py-0 sm:text-sm peer-checked:[&_div]:-rotate-180"
                  htmlFor="resources-drawer"
                >
                  Resources
                  <div className="block transition-smooth sm:hidden">
                    {CARET_DOWN}
                  </div>
                </label>
                <div className="hidden peer-checked:block sm:block">
                  <div className="my-4 flex flex-col space-y-4 text-[13px] text-black/60">
                    <Link to="/blog/" className="hover:text-azure-800">
                      Blog
                    </Link>
                    <Link to="/guides/" className="hover:text-azure-800">
                      Guides & Webinars
                    </Link>
                    <Link
                      to="/calculating-app-actions/"
                      className="hover:text-azure-800"
                    >
                      Calculating App Actions
                    </Link>
                    <a
                      href="https://docs.runalloy.com/"
                      target="_blank"
                      rel="nofollow noreferrer"
                      className="hover:text-azure-800"
                    >
                      Documentation
                    </a>
                    <a
                      href="https://servicedesk.support.runalloy.com/servicedesk/customer/portals"
                      target="_blank"
                      rel="nofollow noreferrer"
                      className="hover:text-azure-800"
                    >
                      File a Support Ticket
                    </a>
                    <Link to="/case-studies/" className="hover:text-azure-800">
                      Case Studies
                    </Link>
                    <Link
                      to="/competitor-overview/"
                      className="hover:text-azure-800"
                    >
                      Alloy vs. the Competitors
                    </Link>
                  </div>
                </div>
              </div>

              {/** Company */}
              <div>
                <input
                  className="peer hidden"
                  id="company-drawer"
                  type="checkbox"
                />
                <label
                  className="flex items-center justify-between border-b border-b-black/10 py-3 text-base font-semibold text-black/80 sm:mt-6 sm:border-none sm:py-0 sm:text-sm peer-checked:[&_div]:-rotate-180"
                  htmlFor="company-drawer"
                >
                  Company
                  <div className="block transition-smooth sm:hidden">
                    {CARET_DOWN}
                  </div>
                </label>
                <div className="hidden peer-checked:block sm:block">
                  <div className="my-4 flex flex-col space-y-4 text-[13px] text-black/60">
                    <Link to="/about-us/" className="hover:text-azure-800">
                      About Us
                    </Link>
                    <Link
                      to="/about-us/#job-openings/"
                      className="hover:text-azure-800"
                    >
                      Careers &nbsp;&nbsp;
                      <span className="rounded-full border border-black/10 bg-azure-100 px-2 py-1 text-xs text-azure-900">
                        We're hiring
                      </span>
                    </Link>
                    <Link to="/partners/" className="hover:text-azure-800">
                      Partners
                    </Link>
                    <Link to="/contact-us/" className="hover:text-azure-800">
                      Contact Us
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-2 flex flex-col items-start justify-center gap-8 py-6 sm:mt-56 sm:flex-row sm:items-center sm:justify-end sm:gap-10 sm:py-8">
            <div className="flex flex-col items-start gap-2 sm:flex-row sm:items-center">
              <div className="text-xs tracking-[0.24px] text-black">
                &copy; {new Date().getFullYear()} Alloy Automation. All rights
                reserved.
              </div>
              <span className="hidden text-black/10 sm:block">〡</span>
              <div className="flex items-center gap-2">
                <Link
                  className="text-xs tracking-[0.24px] text-black hover:text-azure-800"
                  to="/terms/"
                >
                  Terms
                </Link>
                <span className="text-black/10">〡</span>
                <Link
                  className="text-xs tracking-[0.24px] text-black hover:text-azure-800"
                  to="/privacy/"
                >
                  Privacy Policy
                </Link>
                <span className="text-black/10">〡</span>
                <a
                  href="https://status.runalloy.com/"
                  target="_blank"
                  rel="nofollow noreferrer"
                  aria-label="Alloy Integrations Status"
                  className="text-xs tracking-[0.24px] text-black hover:text-azure-800"
                >
                  Status
                </a>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <a
                target="_blank"
                rel="nofollow noreferrer"
                href="https://www.linkedin.com/company/alloy-automation/"
                aria-label="Follow us on LinkedIn"
              >
                <LinkedinLogo size={24} weight="fill" />
              </a>
              <a
                target="_blank"
                rel="nofollow noreferrer"
                href="https://twitter.com/AlloyAutomation"
                aria-label="Follow us on X"
              >
                <XLogo size={24} weight="bold" />
              </a>
              <a
                target="_blank"
                rel="nofollow noreferrer"
                href="https://www.instagram.com/alloyautomation/"
                aria-label="Follow us on Instagram"
              >
                <InstagramLogo size={24} weight="bold" />
              </a>
              <a
                target="_blank"
                rel="nofollow noreferrer"
                href="https://www.facebook.com/AlloyAutomation"
                aria-label="Follow us on Facebook"
              >
                <FacebookLogo size={24} weight="fill" />
              </a>
            </div>
          </div>
          <div className="absolute -bottom-44 left-0 hidden sm:block">
            <img
              src="https://cdn.runalloy.com/landing/2025/alloy-azure.webp"
              alt="alloy"
              className="h-auto w-[411px] mix-blend-multiply"
            />
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default SiteFooter;
